
import {
  defineComponent, reactive, watch, inject, Ref,
} from 'vue';
import Icone from '@/core/components/Icone.vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useModalBase } from '@/core/composables/ModalBase';
import Card from '@/core/components/Tela/Card.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import SelecionarProdutoMovimento from '@/components/Cadastros/Produtos/SelecionarProdutoMovimento.vue';
import SelecionarUnidadeProdutoMovimento from '@/components/Cadastros/Produtos/Unidades/SelecionarUnidadeProdutoMovimento.vue';
import SelecionarSimNao from '@/core/components/Tela/SelecionarSimNao.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import SelecionarCenarioFiscal from '@/components/Cadastros/Tributacoes/CenariosFiscais/SelecionarCenarioFiscal.vue';
import SelecionarCfop from '@/components/Cadastros/Tributacoes/Cfops/SelecionarCfop.vue';
import NotaFiscalItemDetalhe from '@/components/Fiscal/NotasFiscais/NotaFiscalItemDetalhe.vue';
import NotaFiscalItemImpostos from '@/components/Fiscal/NotasFiscais/NotaFiscalItemImpostos.vue';
import NotaFiscalItemEstoques from '@/components/Fiscal/NotasFiscais/NotaFiscalItemEstoques.vue';
import NotaFiscalItemDadosEspecificos from '@/components/Fiscal/NotasFiscais/NotaFiscalItemDadosEspecificos.vue';
import ServicoEstoque from '@/servicos/Cadastros/Estoques/ServicoEstoque';
import ServicoCfop from '@/servicos/Cadastros/Tributacoes/ServicoCfop';
import {
  INotaFiscalIncidenciaCalculo, INotaFiscalItem, INotaFiscalItemCombustivel, INotaFiscalItemEstoque, INotaFiscalItemImposto, INotaFiscalItemImpostoCofins, INotaFiscalItemImpostoIcms, INotaFiscalItemImpostoImportacao, INotaFiscalItemImpostoIpi, INotaFiscalItemImpostoPis, INotaFiscalItemImpostoSubstituicaoTributaria, INotaFiscalItemImpostoIbsCbs, INotaFiscalItemMedicamento,
} from '@/models/Entidades/Fiscal/INotaFiscal';
import UtilitarioDispositivo from '@/core/utilitarios/UtilitarioDispositivo';
import ServicoCalculosComerciais from '@/servicos/ServicoCalculosComerciais';
import { IEstoque } from '@/models/Entidades/Cadastros/Estoques/IEstoque';
import { EOrigemValorItem } from '@/models/Enumeradores/EOrigemValorItem';
import { IDTOPessoaMovimento } from '@/models/DTO/Cadastros/Pessoas/IDTOPessoaMovimento';
import { IParametrosConsultaDefinicaoMovimentacao } from '@/models/ParametrosRequisicao/Cadastros/Tributacoes/IParametrosConsultaDefinicaoMovimentacao';
import { ETipoMovimentoComercial } from '@/core/models/Enumeradores/ETipoMovimentoComercial';
import ServicoCenarioFiscal from '@/servicos/Cadastros/Tributacoes/ServicoCenarioFiscal';
import storeSistema from '@/store/storeSistema';
import { ETipoOperacaoCfop } from '@/models/Enumeradores/Cadastros/Tributacoes/ETipoOperacaoCfop';
import { ICfop } from '@/models/Entidades/Cadastros/Tributacoes/ICfop';
import { IDTODadosEmpresa } from '@/models/DTO/MeuSistema/Empresas/IDTODadosEmpresa';
import ServicoNotaFiscal from '@/servicos/Fiscal/ServicoNotaFiscal';
import { ETipoOperacao } from '@/models/Enumeradores/Fiscal/ETipoOperacao';

export default defineComponent({
  name: 'NotaFiscalItemModal',
  props: {
    visivel: {
      type: Boolean,
    },
    empresa: {
      type: Number,
      required: true,
    },
    pessoa: {
      type: Number,
      required: true,
    },
    dadosPessoaMovimento: {
      type: Object as () => IDTOPessoaMovimento,
      required: true,
    },
    editavel: {
      type: Boolean,
      default: true,
    },
    atualizarApenasInformacoesFiscais: {
      type: Boolean,
      default: false,
    },
    tipoOperacao: {
      type: Number,
      default: 0,
    },
    atualizarValores: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object as () => INotaFiscalItem,
      required: true,
    },
    totalNota: {
      type: Number,
      required: true,
    },
    existeProximo: {
      type: Boolean,
      required: true,
    },
    existeAnterior: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Card,
    Icone,
    SelecionarProdutoMovimento,
    SelecionarUnidadeProdutoMovimento,
    SelecionarSimNao,
    CampoNumerico,
    SelecionarCenarioFiscal,
    SelecionarCfop,
    NotaFiscalItemDetalhe,
    NotaFiscalItemImpostos,
    NotaFiscalItemEstoques,
    NotaFiscalItemDadosEspecificos,
  },
  emits: ['update:visivel', 'salvar', 'proximoItem', 'itemAnterior'],
  setup(props, { emit }) {
    const servicoEstoque = new ServicoEstoque();
    servicoEstoque.requisicaoSistema();

    const servicoCfop = new ServicoCfop();
    servicoCfop.requisicaoSistema();

    const servicoCalculosComerciais = new ServicoCalculosComerciais();
    const servicoCenarioFiscal = new ServicoCenarioFiscal();
    servicoCenarioFiscal.requisicaoSistema();
    const servicoNotaFiscal = new ServicoNotaFiscal();

    const { telaBase, apresentarMensagemAlerta } = useTelaBase();
    const { modalBase } = useModalBase(props, emit);

    const dadosEmpresa = inject('NOTAS_FISCAIS_EMPRESA') as Ref<IDTODadosEmpresa>;
    const incidenciasCalculo = inject('NOTAS_FISCAIS_INCIDENCIA_CALCULO') as INotaFiscalIncidenciaCalculo[];
    const cfopSugerido = inject('NOTAS_FISCAIS_CFOP_SUGERIDO') as Ref<ICfop>;

    const state = reactive({
      item: {} as INotaFiscalItem,
      tabelasPreco: [] as number[],
      estoquesDisponiveis: [] as number[],
      qtdCasasDecimaisCusto: 2,
      totalNota: 0,
      telaMobile: false,
      apresentarTabelasPrecos: false,
      carregando: false,
      tipoOperacaoCfop: {} as ETipoOperacaoCfop,
    });

    function instanciaNovoItem():INotaFiscalItem {
      const itemNotaFiscal = {} as INotaFiscalItem;
      itemNotaFiscal.emDigitacao = false;
      itemNotaFiscal.estoquesDisponiveis = [] as IEstoque[];
      itemNotaFiscal.codigoProdutoDefinicao = 0;
      itemNotaFiscal.codigoUnidadePrincipal = 0;
      itemNotaFiscal.fatorUnidadePrincipal = 1;
      itemNotaFiscal.codigoUnidade = 0;
      itemNotaFiscal.fracionarUnidade = false;
      itemNotaFiscal.siglaUnidade = '';
      itemNotaFiscal.fatorConversao = 1;
      itemNotaFiscal.casasDecimaisUnidade = 2;
      itemNotaFiscal.precoUnitario = 0;
      itemNotaFiscal.casasDecimaisPrecoUnitario = 2;
      itemNotaFiscal.valorDesconto = 0;
      itemNotaFiscal.valorTotal = 0;
      itemNotaFiscal.movimentarEstoque = true;
      itemNotaFiscal.compoeTotal = true;
      itemNotaFiscal.origemFrete = EOrigemValorItem.Rateio;
      itemNotaFiscal.valorFrete = 0;
      itemNotaFiscal.origemOutrasDespesas = EOrigemValorItem.Rateio;
      itemNotaFiscal.origemSeguro = EOrigemValorItem.Rateio;
      itemNotaFiscal.valorSeguro = 0;
      itemNotaFiscal.impostos = {} as INotaFiscalItemImposto;
      itemNotaFiscal.impostos.codigoCfop = 1;
      itemNotaFiscal.impostos.icms = {} as INotaFiscalItemImpostoIcms;
      itemNotaFiscal.impostos.cst = '00';
      itemNotaFiscal.impostos.origemMercadoria = 0;
      itemNotaFiscal.impostos.icms.modalidadeBaseCalculoIcms = 3;
      itemNotaFiscal.impostos.icms.valorIcms = 0;
      itemNotaFiscal.impostos.ipi = {} as INotaFiscalItemImpostoIpi;
      itemNotaFiscal.impostos.ipi.cstIpi = '52';
      itemNotaFiscal.impostos.ipi.tipoCalculoIpi = 1;
      itemNotaFiscal.impostos.ipi.codigoEnquadramentoIpi = '999';
      itemNotaFiscal.impostos.ipi.valorIpi = 0;
      itemNotaFiscal.impostos.pis = {} as INotaFiscalItemImpostoPis;
      itemNotaFiscal.impostos.pis.cstPis = '07';
      itemNotaFiscal.impostos.pis.tipoCalculoPis = 1;
      itemNotaFiscal.impostos.pis.valorPis = 0;
      itemNotaFiscal.impostos.cofins = {} as INotaFiscalItemImpostoCofins;
      itemNotaFiscal.impostos.cofins.cstCofins = '07';
      itemNotaFiscal.impostos.cofins.tipoCalculoCofins = 1;
      itemNotaFiscal.impostos.cofins.valorCofins = 0;
      itemNotaFiscal.impostos.st = {} as INotaFiscalItemImpostoSubstituicaoTributaria;
      itemNotaFiscal.impostos.importacao = {} as INotaFiscalItemImpostoImportacao;
      itemNotaFiscal.impostos.ibsCbs = {} as INotaFiscalItemImpostoIbsCbs;
      itemNotaFiscal.impostos.importacao.valorImportacao = 0;
      itemNotaFiscal.impostos.importacao.valorIof = 0;
      itemNotaFiscal.impostos.importacao.despesasAduaneiras = 0;
      itemNotaFiscal.medicamento = {} as INotaFiscalItemMedicamento;
      itemNotaFiscal.combustivel = {} as INotaFiscalItemCombustivel;
      itemNotaFiscal.estoques = [] as INotaFiscalItemEstoque[];
      return itemNotaFiscal;
    }

    function limparCampos() {
      state.item = instanciaNovoItem();
      state.tabelasPreco = [] as number[];
      state.estoquesDisponiveis = [] as number[];
      state.qtdCasasDecimaisCusto = 2;
      state.totalNota = 0;
      state.telaMobile = UtilitarioDispositivo.larguraTelaMobile();
    }

    function calcularTotalNota() {
      state.totalNota = props.totalNota;
      if (props.item.compoeTotal && state.item.codigo !== undefined) {
        state.totalNota -= props.item.valorTotal;
      }

      if (state.item.compoeTotal) {
        state.totalNota += state.item.valorTotal;
      }
    }

    function atualizarAlteracaoItem() {
      if (props.editavel) {
        state.item.alterado = true;
        state.item = servicoNotaFiscal.calcularTotalItem(state.item);
        calcularTotalNota();
      }
    }

    function validarImpostos() {
      if (!UtilitarioGeral.valorValido(state.item.impostos.cst) && !UtilitarioGeral.valorValido(state.item.impostos.cson)) {
        apresentarMensagemAlerta('O CST/CSOSN deve ser informado!');
        return false;
      }

      if (!UtilitarioGeral.valorValido(state.item.impostos.pis.cstPis)) {
        apresentarMensagemAlerta('O CST do PIS deve ser informado!');
        return false;
      }

      if (!UtilitarioGeral.valorValido(state.item.impostos.cofins.cstCofins)) {
        apresentarMensagemAlerta('O CST do COFINS deve ser informado!');
        return false;
      }
      return true;
    }

    function validarEstoque() {
      if (!state.item.movimentarEstoque) return true;
      let estoqueSemPreencher = false;

      state.item.estoques.forEach((e) => {
        if (!UtilitarioGeral.validaCodigo(e.codigoEstoque)) {
          estoqueSemPreencher = true;
        }
      });

      if (estoqueSemPreencher) {
        apresentarMensagemAlerta('É necessário selecionar o estoque do produto.');
        return false;
      }
      return true;
    }

    function validarPreco() {
      return true;
    }

    function validarCampos() {
      if (state.item.codigoProdutoDefinicao === undefined || state.item.codigoProdutoDefinicao === 0) {
        apresentarMensagemAlerta('O Produto deve ser informado!');
        return false;
      }

      if (state.item.codigoUnidade === undefined || state.item.codigoUnidade === 0) {
        apresentarMensagemAlerta('A Unidade deve ser informada!');
        return false;
      }

      if (state.item.quantidade === undefined || state.item.quantidade < 1) {
        apresentarMensagemAlerta('A Quantidade deve ser informada!');
        return false;
      }

      if (state.item.valorTotal === undefined || state.item.valorTotal < 1) {
        apresentarMensagemAlerta('O Total do Item deve ser informado!');
        return false;
      }

      if (state.item.impostos.codigoCfop === undefined || state.item.impostos.codigoCfop === 0) {
        apresentarMensagemAlerta('O CFOP deve ser informado!');
        return false;
      }

      if (!validarImpostos()) {
        return false;
      }

      if (!validarEstoque()) {
        return false;
      }

      if (!validarPreco()) {
        return false;
      }

      return true;
    }

    function calculaTotalItemEAtualizaTotalNota() {
      state.item.valorTotal = servicoCalculosComerciais.calculaValorTotal(state.item.quantidade, state.item.precoUnitario, state.item.valorDesconto, 0);
      calcularTotalNota();
    }

    function atualizarQtdEstoque() {
      if (state.item.estoques.length === 1) {
        state.item.estoques[0].quantidade = state.item.quantidade;
      }
      calculaTotalItemEAtualizaTotalNota();
    }

    function limparEstoques() {
      state.item.estoques = [] as INotaFiscalItemEstoque[];
    }

    function salvar() {
      state.item.estoques.forEach((estoque, index) => {
        if (state.item.estoques[index].itemNovo) {
          state.item.estoques[index].codigoEstoqueItem = 0;
        }
      });

      if (validarCampos()) {
        if (state.item.codigo === undefined) {
          state.item.codigo = 0;
        } else {
          state.item.alterado = true;
        }
        emit('salvar', state.item);
      }
    }

    async function proximoItem() {
      emit('proximoItem');
    }

    async function itemAnterior() {
      emit('itemAnterior');
    }

    async function obterDadosFiscaisProduto() {
      if (UtilitarioGeral.validaCodigo(state.item.codigoProdutoDefinicao)) {
        const parametrosConsultaDefinicaoMovimentacao: IParametrosConsultaDefinicaoMovimentacao = {} as IParametrosConsultaDefinicaoMovimentacao;
        parametrosConsultaDefinicaoMovimentacao.tipoMovimentoComercial = ETipoMovimentoComercial.Vendas;
        parametrosConsultaDefinicaoMovimentacao.codigoEmpresa = props.empresa;
        parametrosConsultaDefinicaoMovimentacao.codigoEstado = props.dadosPessoaMovimento.codigoEstado;
        parametrosConsultaDefinicaoMovimentacao.tipoAtividade = props.dadosPessoaMovimento.tipoAtividade;
        parametrosConsultaDefinicaoMovimentacao.tipoIe = props.dadosPessoaMovimento.tipoIe;
        parametrosConsultaDefinicaoMovimentacao.pessoaSuperSimples = props.dadosPessoaMovimento.simplesNacional;
        parametrosConsultaDefinicaoMovimentacao.codigoProdutoDefinicao = state.item.codigoProdutoDefinicao;
        parametrosConsultaDefinicaoMovimentacao.codigoNcm = state.item.impostos.codigoNcm;
        parametrosConsultaDefinicaoMovimentacao.origemMercadoria = state.item.impostos.origemMercadoria;

        const definicoesTributarias = await servicoCenarioFiscal.obterDefinicoesMovimentacao(parametrosConsultaDefinicaoMovimentacao);
        if (definicoesTributarias.sucesso) {
          if (definicoesTributarias.encontrouDefinicoesIcms) {
            state.item.impostos.codigoCfop = definicoesTributarias.icms.codigoCfop;
            state.item.impostos.cfop = definicoesTributarias.icms.cfop;
            if (UtilitarioGeral.valorValido(definicoesTributarias.icms.cstIcms)) {
              state.item.impostos.cst = definicoesTributarias.icms.cstIcms;
              state.item.impostos.cson = '';
            } else {
              state.item.impostos.cson = definicoesTributarias.icms.cson;
              state.item.impostos.cst = '';
            }
            state.item.impostos.icms.modalidadeBaseCalculoIcms = definicoesTributarias.icms.modalidadeBaseCalculoIcms;
            state.item.impostos.icms.aliquotaIcms = definicoesTributarias.icms.aliquotaIcms;
            state.item.impostos.icms.reducaoBaseCalculoIcms = definicoesTributarias.icms.reducaoBaseCalculoIcms;
            state.item.impostos.icms.aliquotaFcp = definicoesTributarias.icms.aliquotaFcp;
            state.item.impostos.icms.calcularIcmsInterestadual = definicoesTributarias.icms.calcularIcmsInterestadual;
          }

          if (definicoesTributarias.encontrouDefinicoesSubstituicaoTributaria) {
            state.item.impostos.st.modalidadeBaseCalculoSubstituicao = definicoesTributarias.icms.substituicao.modalidadeBaseCalculoIcmsSubstituicao;
            state.item.impostos.st.aliquotaSubstituicaoTributaria = definicoesTributarias.icms.substituicao.aliquotaIcmsSubstituicao;
            state.item.impostos.st.aliquotaIcmsInterno = definicoesTributarias.icms.substituicao.aliquotaIcmsInterno;
            state.item.impostos.st.margemValorAdicionado = definicoesTributarias.icms.substituicao.margemValorAdicionado;
            state.item.impostos.st.pautaIcmsSubstituicao = definicoesTributarias.icms.substituicao.pautaIcmsSubstituicao;
            state.item.impostos.st.reducaoBaseCalculoSubstituicao = definicoesTributarias.icms.substituicao.reducaoBaseCalculoIcmsSubstituicao;
          }

          if (definicoesTributarias.encontrouDefinicoesIpi) {
            state.item.impostos.ipi.cstIpi = definicoesTributarias.ipi.cstIpi;
            state.item.impostos.ipi.tipoCalculoIpi = definicoesTributarias.ipi.tipoCalculoIpi;
            state.item.impostos.ipi.aliquotaIpi = definicoesTributarias.ipi.aliquotaIpi;
            state.item.impostos.ipi.codigoEnquadramentoIpi = definicoesTributarias.ipi.codigoEnquadramentoIpi;
          }

          if (definicoesTributarias.encontrouDefinicoesPis) {
            state.item.impostos.pis.cstPis = definicoesTributarias.pis.cstPis;
            state.item.impostos.pis.tipoCalculoPis = definicoesTributarias.pis.tipoCalculoPis;
            state.item.impostos.pis.aliquotaPis = definicoesTributarias.pis.aliquotaPis;
            state.item.impostos.pis.reducaoBaseCalculoPis = definicoesTributarias.pis.reducaoBaseCalculoPis;
          }

          if (definicoesTributarias.encontrouDefinicoesCofins) {
            state.item.impostos.cofins.cstCofins = definicoesTributarias.cofins.cstCofins;
            state.item.impostos.cofins.tipoCalculoCofins = definicoesTributarias.cofins.tipoCalculoCofins;
            state.item.impostos.cofins.aliquotaCofins = definicoesTributarias.cofins.aliquotaCofins;
            state.item.impostos.cofins.reducaoBaseCalculoCofins = definicoesTributarias.cofins.reducaoBaseCalculoCofins;
          }
        }

        if (!UtilitarioGeral.validaCodigo(state.item.impostos.codigoCfop) && UtilitarioGeral.objetoValido(cfopSugerido.value)) {
          state.item.impostos.codigoCfop = cfopSugerido.value.codigo;
          state.item.impostos.cfop = cfopSugerido.value.codigoCfop;
        }
      }
    }

    async function calcularTributacoes() {
      state.item.impostos.icms.aliquotaSimplesNacional = dadosEmpresa.value.aliquotaSimplesNacional;
      const retornoCalculoTributacoes = await servicoCalculosComerciais.calcularTributacoes(state.item, incidenciasCalculo, dadosEmpresa.value.uf);
      if (UtilitarioGeral.objetoValido(retornoCalculoTributacoes)) {
        state.item.impostos.icms.baseCalculoIcms = retornoCalculoTributacoes.icms.baseCalculoIcms;
        state.item.impostos.icms.valorIcms = retornoCalculoTributacoes.icms.valorIcms;
        state.item.impostos.icms.valorSimplesNacional = retornoCalculoTributacoes.icms.valorSimplesNacional;

        state.item.impostos.st.baseCalculoSubstituicaoTributaria = retornoCalculoTributacoes.icms.baseCalculoSubstituicaoTributaria;
        state.item.impostos.st.valorSubstituicaoTributaria = retornoCalculoTributacoes.icms.valorSubstituicaoTributaria;

        state.item.impostos.ipi.baseCalculoIpi = retornoCalculoTributacoes.ipi.baseCalculo;
        state.item.impostos.ipi.valorIpi = retornoCalculoTributacoes.ipi.valor;

        state.item.impostos.pis.baseCalculoPis = retornoCalculoTributacoes.pis.baseCalculo;
        state.item.impostos.pis.valorPis = retornoCalculoTributacoes.pis.valor;

        state.item.impostos.cofins.baseCalculoCofins = retornoCalculoTributacoes.cofins.baseCalculo;
        state.item.impostos.cofins.valorCofins = retornoCalculoTributacoes.cofins.valor;

        state.item.impostos.valorTotalTributos = retornoCalculoTributacoes.valorTotalTributos;
      }
    }

    function defineValorUnitarioCalculaTotal(precoUnitario: number) {
      if (props.editavel) {
        state.item.precoUnitario = precoUnitario;
        state.item = servicoNotaFiscal.calcularTotalItem(state.item);
        calcularTotalNota();
      }
    }

    watch(async () => modalBase.computedVisivel, async () => {
      telaBase.carregando = true;
      limparCampos();
      if (modalBase.computedVisivel) {
        const dadosEmpresa = storeSistema.state.empresasDisponiveis.find((c) => c.codigoEmpresa === props.empresa);

        if (dadosEmpresa !== undefined) {
          if (props.dadosPessoaMovimento.uf === dadosEmpresa.uf) {
            state.tipoOperacaoCfop = (props.tipoOperacao === ETipoOperacao.Entrada) ? ETipoOperacaoCfop.EntradaDentroEstado : ETipoOperacaoCfop.SaidaDentroEstado;
          } else if (props.dadosPessoaMovimento.uf === 'EX') {
            state.tipoOperacaoCfop = (props.tipoOperacao === ETipoOperacao.Entrada) ? ETipoOperacaoCfop.EntradaImportacao : ETipoOperacaoCfop.SaidaExportacao;
          } else {
            state.tipoOperacaoCfop = (props.tipoOperacao === ETipoOperacao.Entrada) ? ETipoOperacaoCfop.EntradaForaEstado : ETipoOperacaoCfop.SaidaForaEstado;
          }
        }
        state.item = UtilitarioGeral.clonarObjeto(props.item);
      }
      telaBase.carregando = false;
    });

    watch(async () => props.item, async () => {
      state.item = props.item;
    });

    function verificaEdicaoCampoEInformacaoFiscal():boolean {
      if (props.atualizarApenasInformacoesFiscais) {
        return false;
      }

      return !props.editavel;
    }

    return {
      props,
      state,
      telaBase,
      modalBase,
      UtilitarioGeral,
      UtilitarioMascara,
      limparEstoques,
      salvar,
      proximoItem,
      itemAnterior,
      calcularTotalNota,
      atualizarQtdEstoque,
      calculaTotalItemEAtualizaTotalNota,
      calcularTributacoes,
      obterDadosFiscaisProduto,
      atualizarAlteracaoItem,
      defineValorUnitarioCalculaTotal,
      verificaEdicaoCampoEInformacaoFiscal,
    };
  },
});
